import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a39d01e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mt-6",
  align: "center"
}

import { useI18n } from "vue-i18n"
import { computed, onBeforeUnmount, ref, watch } from "vue"
import { Universities } from "@/types"
import HospitalHeader from "../Headers/HospitalHeader.vue"
import router from "@/router"
import { onMounted } from "vue"

import FooterComponent from "@/components/Footer/FooterComponent.vue"
import { useRoute } from "vue-router"
import { hospitalActions } from "@/stores/hospital-actions"


export default /*#__PURE__*/_defineComponent({
  __name: 'HospitalProfile',
  setup(__props) {

const { t } = useI18n()

const hospitalAction = hospitalActions()
const isLoading = ref(false)
const token = ref(localStorage.getItem("docAccessToken") ?? "")
const responseStatus = ref({})
const val = ref(true)
const selectedItem = ref<string>("info")
const universities = ref<Universities[]>([])
const route = useRoute()
const smallWindow = ref(window.innerWidth < 600)

onMounted(async () => {
  await getUniversities()
  navigateTo((routeName.value as string) ?? "Hospital General Information")
})

const routeName = computed(() => {
  return route.name
})

watch([routeName], () => {
  selectedItem.value =
    (routeName.value as string) ?? "Hospital General Information"
})

onMounted(() => {
  window.addEventListener("resize", updateWindowSize)
})

onBeforeUnmount(() => {
  window.removeEventListener("resize", updateWindowSize)
})

const updateWindowSize = (): void => {
  smallWindow.value = window.innerWidth < 1000
}

const getUniversities = async () => {
  isLoading.value = true
  const response = await hospitalAction.getUniversities()
  responseStatus.value = response
  if (response.success) {
    universities.value = response.result as Universities[]
  }
  isLoading.value = false
}

const name = computed(() => {
  return `${hospitalAction.hospitalName}`
})

const navigateTo = (item: string) => {
  selectedItem.value = item
  router.push({ name: item })
}

return (_ctx: any,_cache: any) => {
  const _component_request_status = _resolveComponent("request-status")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HospitalHeader),
    _createVNode(_component_request_status, {
      class: "mt-6",
      response: responseStatus.value,
      isLoading: isLoading.value
    }, null, 8, ["response", "isLoading"]),
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_layout, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_navigation_drawer, {
                    "expand-on-hover": smallWindow.value,
                    rail: smallWindow.value,
                    permanent: !smallWindow.value,
                    "mobile-breakpoint": "xs",
                    width: "260",
                    height: "100vh"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, { align: "start" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, {
                            "prepend-avatar": 
                _unref(hospitalAction).hospitalProfileLink != '' &&
                _unref(hospitalAction).hospitalProfileLink != undefined
                  ? _unref(hospitalAction).hospitalProfileLink
                  : require('../../../assets/blank.png')
              ,
                            title: name.value
                          }, null, 8, ["prepend-avatar", "title"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_divider),
                      _createVNode(_component_v_list, {
                        density: "compact",
                        nav: "",
                        align: "start"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, {
                            "prepend-icon": "mdi-account",
                            title: _ctx.$t('general-info'),
                            class: _normalizeClass({
                'v-list-item--active':
                  selectedItem.value === 'Hospital General Information',
              }),
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (navigateTo('Hospital General Information')))
                          }, null, 8, ["title", "class"]),
                          _createVNode(_component_v_list_item, {
                            "prepend-icon": "mdi-hospital",
                            title: _ctx.$t('doctor.interns'),
                            class: _normalizeClass({
                'v-list-item--active':
                  selectedItem.value === 'Hospital Internship Information',
              }),
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (navigateTo('Hospital Internship Information')))
                          }, null, 8, ["title", "class"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["expand-on-hover", "rail", "permanent"]),
                  _createVNode(_component_v_main, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_view)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(FooterComponent, { class: "mb-15" })
  ], 64))
}
}

})